export default function getFileExtension(fileName) {
  const reg = new RegExp(/\.[0-9a-z]+$/i);
  try {
    return fileName.match(reg)[0];
  } catch (error) {
    return "";
  }
}
